











import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "LandingButton",
  components: { BaseButton },
  props: {
    to: { type: Object as () => Location },
    href: { type: String },
    target: { type: String },
    secondary: { type: Boolean },
    black: { type: Boolean },
    medium: { type: Boolean },
    fullWidth: { type: Boolean },
  },
});
